import { useDhamLang, type DhamLang } from '../../context/ManaunaDhamLangContext'
import { Globe } from 'lucide-react'
import { useState, useRef, useEffect } from 'react'

const options: { value: DhamLang; label: string; flag: string }[] = [
  { value: 'en', label: 'English', flag: 'EN' },
  { value: 'hi', label: 'हिन्दी', flag: 'हि' },
  { value: 'hinglish', label: 'Hinglish', flag: 'Hi' },
]

export default function LangToggle() {
  const { lang, setLang } = useDhamLang()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const current = options.find((o) => o.value === lang)!

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 rounded-full bg-white/90 backdrop-blur-md border border-secondary-200 shadow-lg px-4 py-2.5 text-sm font-semibold text-secondary-800 hover:bg-white transition-colors"
      >
        <Globe className="h-4 w-4 text-primary-600" />
        <span>{current.flag}</span>
      </button>
      {open && (
        <div className="absolute right-0 bottom-full mb-2 w-40 rounded-xl bg-white border border-secondary-200 shadow-2xl overflow-hidden z-50">
          {options.map((o) => (
            <button
              key={o.value}
              onClick={() => { setLang(o.value); setOpen(false) }}
              className={`w-full text-left px-4 py-3 text-sm font-medium transition-colors flex items-center gap-3
                ${lang === o.value
                  ? 'bg-primary-50 text-primary-800'
                  : 'text-secondary-700 hover:bg-secondary-50'
                }`}
            >
              <span className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center text-xs font-bold">
                {o.flag}
              </span>
              {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
